export default "__VITE_ASSET__iO$l4Ubr__"